jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

// Inject CSS for shake animation
const style = document.createElement('style');
style.innerHTML = `
@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}
.shake {
  animation: shake 0.5s ease-in-out;
}
`;
document.head.appendChild(style);

// Function to apply shake
function startShaking(button) {
  setInterval(() => {
    button.classList.add('shake');
    setTimeout(() => {
      button.classList.remove('shake');
    }, 500); // match the animation duration
  }, 4000); // shake every 4 seconds
}

// Poll for the payment button until it appears
const pollForButton = setInterval(() => {
  const button = document.querySelector('.shopify-payment-button__button--unbranded');
  if (button) {
    clearInterval(pollForButton); // stop polling
    startShaking(button);         // start the shake loop
  }
}, 500); // check every 500ms


